import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Box, CircularProgress, Typography } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import { ProtectedRoute } from './components/Auth/ProtectedRoute';
import { AuthCallback } from './components/Auth/AuthCallback';
import { MainLayout } from './components/Layout/MainLayout';
import { Dashboard } from './pages/Dashboard';
import { BlacklistPage } from './pages/BlacklistPage';
import { WhitelistPage } from './pages/WhitelistPage';
import { EventsPage } from './pages/EventsPage';
import { ImportSourcesPage } from './pages/ImportSourcesPage';
import { ConfigurationPage } from './pages/ConfigurationPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { ApiKeysPage } from './pages/ApiKeysPage';
import { CustomersPage } from './pages/CustomersPage';

function App() {
  const auth = useAuth();

  // Handle authentication loading state
  if (auth.isLoading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        sx={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: 4,
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 10px 40px -10px rgba(99, 102, 241, 0.5)',
            mb: 3,
          }}
        >
          <SecurityIcon sx={{ fontSize: 44, color: 'white' }} />
        </Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: '#1e293b',
            mb: 1,
          }}
        >
          Honeypot Central
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: '#64748b', mb: 3 }}
        >
          Loading...
        </Typography>
        <CircularProgress
          size={32}
          sx={{
            color: '#6366f1',
          }}
        />
      </Box>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/callback" element={<AuthCallback />} />

        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/blacklist" element={<BlacklistPage />} />
                  <Route path="/whitelist" element={<WhitelistPage />} />
                  <Route path="/events" element={<EventsPage />} />
                  <Route path="/import-sources" element={<ImportSourcesPage />} />
                  <Route path="/api-keys" element={<ApiKeysPage />} />
                  <Route path="/customers" element={<CustomersPage />} />
                  <Route path="/configuration" element={<ConfigurationPage />} />
                  <Route path="/audit-logs" element={<AuditLogPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </MainLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
